import React from 'react';
import { motion } from 'framer-motion';
import { MailIcon } from 'lucide-react';
interface PriceSectionProps {
  id: string;
}
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 24
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true,
    margin: '-60px'
  },
  transition: {
    duration: 0.5,
    ease: 'easeOut'
  }
};
export function PriceSection({
  id
}: PriceSectionProps) {
  return <section id={id} className="w-full px-5 py-16 md:py-24" data-id="element-272">
      <div className="max-w-xl mx-auto" data-id="element-273">
        <motion.div {...fadeInUp} className="bg-white rounded-2xl p-8 md:p-10 border border-[#B8A99A]/20 shadow-xl shadow-[#2C2825]/5 text-center" data-id="element-274">
          <h2 className="text-2xl md:text-3xl font-semibold text-[#2C2825] mb-8 leading-snug" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-275">
            Tu Mapa de Ojeras™ - Rápido, fácil y aplicable. Cara más
            descansada.
          </h2>

          {/* Price */}
          <div className="flex items-center justify-center gap-4 mb-3" data-id="element-276">
            <span className="text-xl text-[#2C2825]/40 line-through" data-id="element-277">
              19,99 €
            </span>
            <span className="text-5xl md:text-6xl font-bold text-[#2C2825]" data-id="element-278">
              6,36 €
            </span>
            <span className="inline-flex items-center px-3 py-1 text-sm font-bold text-white bg-[#C4956A] rounded-full" data-id="element-279">
              -68%
            </span>
          </div>

          <p className="text-[#2C2825]/55 text-sm mb-8" data-id="element-280">
            Pago único · Sin suscripción · Descarga por email al instante
          </p>

          {/* CTA */}
          <button onClick={() => {
          const base = 'https://warame.com/products/mapa-de-ojeras-7-dias';
          window.location.assign(base + window.location.search);
        }} className="block w-full px-8 py-4 bg-[#C4956A] hover:bg-[#A87B54] text-white font-semibold text-base md:text-lg rounded-xl transition-colors duration-200 shadow-lg shadow-[#C4956A]/25 text-center cursor-pointer" data-id="element-281">
            Sí, quiero mi Mapa de Ojeras™ (7 días)
          </button>

          {/* Microcopy */}
          <div className="mt-5 space-y-2" data-id="element-282">
            <p className="flex items-center justify-center gap-2 text-sm text-[#2C2825]/50" data-id="element-283">
              <MailIcon className="w-4 h-4" data-id="element-284" />
              Recibes todo en tu email en menos de 5 minutos
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}